module.exports = __webpack_public_path__ + "static/img/bg.12c0d9a6.jpg";